import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import PortalData from "./PortalModel/PortalData"

export default function PortalsGetObservable(name: string, showInactive: boolean = false): Observable<PortalData[]> {
  const requestBody: string = JSON.stringify({ CompanyName: name, ShowAll: showInactive })

  return ObservableFromFetch<PortalData[]>("FFOrderClinicFileMaintenance/GetClinicInformation", requestBody)
}

export function PortalGetObservable(implementationId: number) {
  const requestBody: string = new URLSearchParams({ ImplementationID: implementationId.toString() }).toString()

  return ObservableFromFetch<PortalData>("FFOrderClinicFileMaintenance/GetPortal?" + requestBody)
}
